import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "create-form"
}
const _hoisted_2 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_4 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1)
const _hoisted_6 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Type", -1)
const _hoisted_8 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "position" }, "Position", -1)
const _hoisted_10 = { class: "cta-section" }
const _hoisted_11 = {
  key: 1,
  class: "create-pending"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Creating channel...", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "create-complete"
}
const _hoisted_15 = { class: "cta-section flex flex-row gap-3 justify-content-end" }

import { watch } from 'vue';
import { useGuildStore } from '@/stores/GuildStore';
import { useApiStatusStore } from '@/stores/ApiStatusStore';
import { useDialogStore } from '@/stores/DialogStore';
import { ErrorMessage, useForm, configure, GenericObject } from 'vee-validate';
import * as yup from 'yup';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';
import { ChannelGroup, CreateChannelPayload } from '@/models/channel-list.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildChannelCreate',
  props: {
    props: {}
  },
  setup(__props: any) {

const guildStore = useGuildStore();
const apiStatusStore = useApiStatusStore();
const dialogStore = useDialogStore();

const props = __props;

const schema = yup.object({
  name: yup.string().min(4).required(),
  description: yup.string(),
  type: yup.number().required(), //option 1 = Chat, 2 = Announcements, 3 = Voice, 4 = Advanced voice
  position: yup.number(),
});

const channelTypes = [
  { id: 1, name: 'Chat' },
  { id: 2, name: 'Announcements' },
  { id: 3, name: 'Voice' },
  { id: 4, name: 'Advanced Voice' },
];

const { defineField, handleSubmit } = useForm({
  validationSchema: schema,
});

configure({
  validateOnBlur: true,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false
})

const [name] = defineField('name');
const [description] = defineField('description');
const [type] = defineField('type');
const [position] = defineField('position');

const onSubmit = handleSubmit((values: GenericObject) => {
  if(guildStore.guild){
    const body: CreateChannelPayload = {
      guildId: guildStore.guild.id,
      channelGroupId: props.props.group.id,
      name: values.name,
      description: values.description,
      type: values.type,
      position: values.position,
    }
    guildStore.createChannel(body);
  } else {
    console.error('Cannot create channel, guild is undefined');
  }
});

watch(() => apiStatusStore.requestFulfilled('post_channel'), (newValue) => {
  if (newValue) {
    useDialogStore().changeHeader('Channel succesfully created!')
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(apiStatusStore).requests.get('post_channel'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_unref(InputText), {
                modelValue: _unref(name),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                id: "name"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(ErrorMessage), { name: "name" })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_unref(InputText), {
                modelValue: _unref(description),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(description) ? (description).value = $event : null)),
                id: "description"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(ErrorMessage), { name: "description" })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_unref(Dropdown), {
                modelValue: _unref(type),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(type) ? (type).value = $event : null)),
                id: "type",
                options: channelTypes,
                optionLabel: "name",
                optionValue: "id"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(ErrorMessage), { name: "type" })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_unref(InputText), {
                modelValue: _unref(position),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(position) ? (position).value = $event : null)),
                id: "position",
                type: "number"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(ErrorMessage), { name: "position" })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(Button), {
                label: "Cancel",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(dialogStore).closeDialog()))
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                label: "Create Channel",
                disabled: _unref(apiStatusStore).requestPending('post_channel')
              }, null, 8, ["disabled"])
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestPending('post_channel'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestFulfilled('post_channel'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(Button), {
              label: "Close",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(dialogStore).closeDialog()))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})